import { render, staticRenderFns } from "./ContactImg.vue?vue&type=template&id=4f3a8d12&"
import script from "./ContactImg.vue?vue&type=script&lang=js&"
export * from "./ContactImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports